module.exports = __webpack_public_path__ + "static/media/35.d9ae648c.jpg";